import React from 'react';
import SignedImage from '@/components/ipe/SignedImage';

const PLACEHOLDER = <span className="ipe-signed-image-placeholder" aria-hidden />;

/**
 * AI 工作室「原图」缩略图：优先 previewUrl（含上传时 blob 兜底），懒加载 + thumb，
 * 避免大批量 eager 读图触发 429 裂图；alt 置空，无障碍由外层按钮 aria-label 承担。
 */
export default function StudioRefSourceImage({
  item,
  alt,
  className,
  loading = 'lazy',
  variant = 'thumb',
  ...rest
}) {
  if (!item?.url && !item?.dataUrl && !item?.previewUrl && !item?.apiUrl) {
    return PLACEHOLDER;
  }
  const dataUrlPreview = item.dataUrl?.startsWith('data:image/') ? item.dataUrl : '';
  const blobPreview = String(item.previewUrl || '').startsWith('blob:')
    ? String(item.previewUrl)
    : '';
  const preview = item.previewUrl || item.viewUrl || item.displayUrl || dataUrlPreview;
  const canonicalUrl = item.url || item.apiUrl || '';

  return (
    <SignedImage
      url={canonicalUrl || dataUrlPreview || blobPreview}
      displayUrl={preview}
      viewUrl={preview}
      record={{
        id: item.id,
        viewUrl: preview,
        displayUrl: preview,
      }}
      alt=""
      className={className}
      loading={loading}
      variant={variant}
      loadingFallback={PLACEHOLDER}
      fallback={blobPreview || dataUrlPreview || PLACEHOLDER}
      {...rest}
    />
  );
}
